import React, {FunctionComponent} from "react";
import {Col, Input} from "reactstrap";
import {dateUtils} from "../../../../utils/dateUtils";
import {OrderItemDefaultSelectable, OrderItemReferenceValue} from "../../../../interfaces/OrderItemInterfaces";
import {OrderBasicWithReferenceItemsSelectable} from "../../../../interfaces/OrderInterfaces";
import {moneyUtils} from "../../../../utils/moneyUtils";

interface OrderItemsFormTableRowDetailsProps {
  orderItem: OrderItemDefaultSelectable,
  currentOrder: OrderBasicWithReferenceItemsSelectable
  ordersSelectable: OrderBasicWithReferenceItemsSelectable[]
  setOrdersSelectable: (orders: OrderBasicWithReferenceItemsSelectable[]) => void
  referenceType: OrderItemReferenceValue
}

const OrderItemsFormTableRowDetails: FunctionComponent<OrderItemsFormTableRowDetailsProps> = ({
  orderItem,
  currentOrder,
  ordersSelectable,
  setOrdersSelectable,
  referenceType,
}) => {

  const handleSubItemSelect = (value: OrderItemDefaultSelectable, checked: boolean) => {
    setOrdersSelectable(ordersSelectable.map(order => {
      if (order.id === currentOrder.id) {
        return {
          ...order,
          isSelected: checked,
          itemsWithReference: order.itemsWithReference.map(orderItem => {
            if (orderItem.id === value.id) {
              return {
                ...orderItem,
                isSelected: checked
              }
            }
            return orderItem
          })
        }
      }
      return order
    }))
  }

  return (
    <div className="epow-custom-table-row-details ms-2">
      <div className="d-flex flex-row w-100">
        <Col xs={1}>
          <Input
            className=""
            type="checkbox"
            checked={orderItem.isSelected}
            onChange={() => {
              handleSubItemSelect(orderItem, !orderItem.isSelected)
            }}
          />
        </Col>
        <Col md={4}>
          {orderItem.name || "-"}
        </Col>
        <Col md={3}>
          <>{dateUtils.formatDateDayJs(orderItem?.rendezVousDate)} - {dateUtils.formatLocalTime(orderItem?.rendezVousHour)}</>
        </Col>
        <Col md={1}>
          {dateUtils.formatDuration(orderItem?.duration)}
        </Col>
        <Col md={1}>
          {orderItem?.pax}
        </Col>
        {referenceType === OrderItemReferenceValue.DESCRIPTION ? (
          <Col md={14}>
            <p><span className="text-decoration-line-through">{orderItem.description || "-"}</span></p>
            <p><span className="fw-bold">{orderItem.referenceDescription || "-"}</span></p>
          </Col>
        ): (
          <Col md={14}>
            <p><span className="text-decoration-line-through">{moneyUtils.formatNumberToCurrency(orderItem.paxPrice) || "-"}</span></p>
            <p><span className="fw-bold">{moneyUtils.formatNumberToCurrency(orderItem.referencePrice) || "-"}</span></p>
          </Col>
        )}
      </div>
    </div>
  )
}

export default OrderItemsFormTableRowDetails
